import React, { useState, useEffect } from "react";
import "../../../../assets/scss/home.scss";
import "../../../../assets/scss/tests.scss";
import "flatpickr/dist/flatpickr.css";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-daterangepicker/daterangepicker.css";
import { Card } from "reactstrap";
import x_mark from "../../../../assets/images/courses/group.svg";
import PaginatedItemsFlashcard from "../../../../components/tables/paginationResultFlashcard";
import { useLocation, useHistory } from "react-router-dom";

const ResultTryForFreeFlashcard = (props) => {
    const location = useLocation();
    const history = useHistory();

    const testType = location.state?.testType;
    let array = location.state?.array;
    let flashId = location.state?.flashId;
    let noteData = location.state?.noteData;
    let notes = location.state?.notes;
    let flashcard_id = location.state?.flashcard_id;
    let flashcard_name = location.state?.flashcard_name;
    let scoreResult = location.state?.scoreResult;
    let scoreDataNumber = location.state?.scoreDataNumber;
    let scoreData = JSON.parse(location.state?.scoreData);

    function checkTypeTest(count) {
        return `Flashcard - ${count} Questions`;
    }

    const redoFlashcard = () => {
        localStorage.setItem("isCreate", false);
        history.push({
            pathname: "/flashcardTest",
            state: { array, testType, notes, flashcard_id, noteData },
        });
    };
    return (
        <div>
            <Card className="mt-4 resultCard">
                <div>
                    <div className="resultHeader">
                        <h1>Results</h1>

                        <img
                            src={x_mark}
                            alt="x_mark"
                            onClick={() => {
                                history.push({
                                    pathname: "/tryforfree",
                                });
                            }}
                        />
                    </div>
                </div>

                <div className="accountingHeaderContentresulttest">
                    <h1>{flashcard_name}</h1>
                </div>
                <div className="testType">
                    <div>
                        <span>{checkTypeTest(array.length)}</span>
                    </div>
                </div>
                <div className="accountingHeaderContentresulttest">
                    <h1>
                        Your Score:{" "}
                        {scoreData.count_right_nswer +
                            "/" +
                            scoreData.questions_count +
                            "(" +
                            scoreDataNumber +
                            "%)"}
                    </h1>
                </div>
                <div className="buttonsDivResult">
                    <button
                        className="finish"
                        onClick={() => {
                            history.push({
                                pathname: "/tryforfree",
                            });
                        }}
                    >
                        Finish
                    </button>
                    <button
                        onClick={() => {
                            redoFlashcard();
                        }}
                    >
                        Re-take
                    </button>
                </div>

                <div className=" pgItems ">
                    <PaginatedItemsFlashcard
                        itemsPerPage={4}
                        items={array}
                        scoreResult={scoreResult}
                        flashId={flashId}
                        isCreate={false}
                    />
                </div>
            </Card>
        </div>
    );
};

export default ResultTryForFreeFlashcard;
